/* istanbul ignore file: this file is only for configuration */

import { Environment } from 'models/Environment';
import { appendHost } from './appendHost';

const SHOPSEARCH_API_URLS: { [environment in Environment]: string } = {
  loc: 'https://shop-search-api.trustedshops.com/shopsearch',
  vrt: appendHost('/api/shopsearch/'),
  integr: 'https://shop-search-api-qa.trustedshops.com/shopsearch',
  qa: 'https://shop-search-api-qa.trustedshops.com/shopsearch',
  production: 'https://shop-search-api.trustedshops.com/shopsearch'
};

const CATEGORY_API_URLS: { [environment in Environment]: string } = {
  loc: 'https://shop-search-category-api.trustedshops.com',
  vrt: appendHost('/api/categories/'),
  integr: 'https://shop-search-category-api-qa.trustedshops.com',
  qa: 'https://shop-search-category-api-qa.trustedshops.com',
  production: 'https://shop-search-category-api.trustedshops.com'
};

const KEYWORD_API_URLS: { [environment in Environment]: string } = {
  loc: 'https://shop-search-keyword-api.trustedshops.com',
  vrt: appendHost('/api/keywords/'),
  integr: 'https://shop-search-keyword-api-qa.trustedshops.com',
  qa: 'https://shop-search-keyword-api-qa.trustedshops.com',
  production: 'https://shop-search-keyword-api.trustedshops.com'
};

export const APPLE_TOUCH_ICON_LINK = '/apple-touch-icon.png';
export const FAVICON_32x32_LINK = '/favicon-32x32.png';
export const FAVICON_16x16_LINK = '/favicon-16x16.png';
export const FAVICON_LINK = '/favicon.ico';

export function determineShopSearchApiUrl(environment: Environment) {
  return SHOPSEARCH_API_URLS[environment];
}

export function determineCategoryApiUrl(environment: Environment) {
  return CATEGORY_API_URLS[environment];
}

export function determineKeywordApiUrl(environment: Environment) {
  return KEYWORD_API_URLS[environment];
}
